/* eslint-disable @typescript-eslint/no-unused-vars */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectOfferFromHistory, selectOffersHistory } from 'shared/selectors/offersHistory';
import { resetOffersHistoryListingState, setActiveOfferId } from 'shared/slices/offersHistory';

import { IThunkApi } from 'shared/types/redux';
import { requestAuthentication } from '../authentication';
import { getOfferFromHistory } from './getOfferFromHistory';

interface IParams {
  cianId?: number | null;
  isDesktop?: boolean;
}

export const openOfferFromHistory = createAsyncThunk<void, IParams | undefined, IThunkApi>(
  'offersHistory/openOfferFromHistory',
  async (params, { getState, dispatch }) => {
    let state = getState();
    const {
      data: { listing: offersHistoryData, listingSpoiler: offersHistorySpoilerData },
      activeOfferId,
    } = selectOffersHistory(state);

    /** Выбираем id оффера, который нужно загрузить, в порядке приоритета */
    const cianId =
      params?.cianId || offersHistoryData.data?.offers?.[0]?.id || offersHistorySpoilerData.data?.offers?.[0]?.id;

    /** Проверка на то, что вызывается открытие другого оффера */
    if (!cianId || activeOfferId === cianId) {
      return;
    }

    dispatch(setActiveOfferId(cianId));

    state = getState();

    const savedOfferFromHistory = selectOfferFromHistory(state);

    dispatch(resetOffersHistoryListingState());

    /** Повторно данные оффера загружаться не будут */
    /* istanbul ignore next */
    if (savedOfferFromHistory) {
      return;
    }

    await dispatch(getOfferFromHistory({ cianId }));

    state = getState();

    const {
      data: {
        listing: { isAuthError },
      },
    } = selectOffersHistory(state);

    /* istanbul ignore next */
    if (isAuthError && !params?.isDesktop) {
      dispatch(setActiveOfferId(null));
      dispatch(
        requestAuthentication({
          onSuccess: () => dispatch(openOfferFromHistory(params)),
        }),
      );
    }
  },
);
